




























import { PartnerPracticeEmailAttachment } from '@/shared/partner-practice-email-attachment';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PartnerPracticeEmailList extends Vue {
    @Prop({ required: true }) private emailAttachments!: Array<PartnerPracticeEmailAttachment>;

    private displayName(attachment: PartnerPracticeEmailAttachment): string {
        return attachment.attachmentAlias == null || attachment.attachmentAlias.trim() === '' ? attachment.attachmentFilename! : attachment.attachmentAlias!;
    }

    private onAddAttachment(): void {
        this.$emit('add');
    }
}
